<app-tab-layout [loading]="loading()" [error]="error">
  @if(initialized()) {

  <ng-template #selectActionTemplate let-onClick="onClick" let-disabled="disabled">
    <button [buttonTheme]="'primary'" [buttonType]="'square'" class="action-button var(--casper-500)"
      (click)="onClick(); $event.stopPropagation()" [disabled]="disabled">
      <ng-icon [name]="'plus'" size="18"></ng-icon>
      <span>{{ dictionaryService.get('Add') }}</span>
    </button>
  </ng-template>

  <ng-template #rowActionTemplate let-onClick="onClick" let-row="row">
    @if (!isCustomerAssigned(row)) {
      <button [buttonType]="'regular'" [buttonTheme]="'light'" style="align-self: center"
        (click)="onClick(); $event.stopPropagation()">
        <ng-icon size="18" strokeWidth="2" [name]="'plus'"></ng-icon>
      </button>
    }
  </ng-template>

  <app-api-table [endpoint]="'/customers/tables/company'" [name]="name" [hasIndexCol]="true" [canSelect]="true"
    [canExport]="false" [canCopy]="false"
    [actionCol]="isManagement ? [] : [
      {
        actionButton: rowActionTemplate,
        onClick: handleRowSelect,
        headerName: 'Add'
      }
    ]" [selectOptions]="isManagement ? undefined : {
      actionButton: selectActionTemplate,
      onSelect: handleBulkSelect,
    }" [chartColumn]="'Name'"></app-api-table>
  }
</app-tab-layout>
